



export const detectOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }
    if (/android/i.test(userAgent)) {
        return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }
    if (/Mac/i.test(userAgent)) {
        return 'MacOS';
    }
    if (/Win/i.test(userAgent)) {
        return 'Windows';
    }
    if (/Linux/i.test(userAgent)) {
        return 'Linux';
    }
    return 'Unknown OS';
};